import type { SVGProps } from 'react';
const SvgChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" {...props}>
    <path fill="currentColor" d="m6.47 4-.94.94L8.583 8 5.53 11.06l.94.94 4-4z" />
  </svg>
);
export default SvgChevronRight;
